import { GiftIcon } from 'lucide-react';
import type { GiftTier } from '../../data/gifts';
import { euro } from '../../core/format/currency';
import { easeCss } from '../../core/format/motion';
type Props = {
  subtotal: number;
  tiers: GiftTier[];
  next: GiftTier | null | undefined;
};

/** Compacte cadeaubalk: één zin, één lijn. Het product blijft de hoofdrol spelen. */
export function GiftProgress({
  subtotal,
  tiers,
  next
}: Props) {
  const top = tiers[tiers.length - 1];
  // Geen cadeaustaffel ingesteld (alle treden weggehaald in het beheer): dan geen balk.
  if (!top || top.threshold <= 0) return null;
  const progress = Math.min(100, subtotal / top.threshold * 100);
  const sentence = next ? `Nog ${euro(next.threshold - subtotal)} tot ${next.phrase}` : 'Alle cadeaus zijn vrijgespeeld';
  return <div className="bg-sand px-4 pb-5 pt-4" data-id="element-6966" data-mp="3ijzls23vs4j0">
      <p className="flex items-start gap-2 text-[14px] leading-snug text-ink" data-id="element-6967" data-mp="3il11wkzr7h7l">
        <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-6968" data-mp="3dm7vtdmsqshg" />
        {next ? <span data-id="element-6969" data-mp="g0omid029pl6">
            Nog <span className="font-medium" data-id="element-6970" data-mp="fx0slcqpf15x">{euro(next.threshold - subtotal)}</span> tot {next.phrase}
          </span> : <span data-id="element-6971" data-mp="pxkt2d6eg1n3">{sentence}</span>}
      </p>

      <div className="relative mx-1 mt-4 h-0.5 bg-line" role="progressbar" aria-valuemin={0} aria-valuemax={top.threshold} aria-valuenow={Math.min(subtotal, top.threshold)}
    // Schermlezers horen de zin, niet "37 procent".
    aria-valuetext={sentence} aria-label="Voortgang naar cadeaus" data-id="element-6972" data-mp="pw00uu7k4use">
        <div className="absolute inset-y-0 left-0 bg-clay" style={{
        width: `${progress}%`,
        transition: `width 300ms ${easeCss}`
      }} data-id="element-6973" data-mp="18n98sz1ojbhv" />
        {tiers.map(t => {
        const hit = subtotal >= t.threshold;
        return <span key={t.threshold} aria-hidden="true" className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2" style={{
          left: `${t.threshold / top.threshold * 100}%`
        }} data-id="element-6974" data-mp="3agqgg2pt8ccm">
              <span className={`block h-2.5 w-2.5 rounded-full border transition-colors duration-200 ease-soft ${hit ? 'border-clay bg-clay' : 'border-line bg-shell'}`} data-id="element-6975" data-mp="32epufyvlwms9" />
              <span className={`absolute left-1/2 top-4 -translate-x-1/2 whitespace-nowrap text-[12px] ${hit ? 'text-clay' : 'text-muted'}`} data-id="element-6976" data-mp="3h9nn6suo3e9v">{euro(t.threshold)}</span>
            </span>;
      })}
      </div>

      {/* Wat vrijgespeeld is staat als eigen regels onder de producten (CartGifts); hier alleen ruimte voor de bedragen. */}
      <div className="h-4" aria-hidden="true" data-id="element-6977" data-mp="3xdixkx1tqg9" />
    </div>;
}